import * as actionTypes from "./actionTypes";

export const getCouponsBasedOnDomainAction = () => ({
  type: actionTypes.GET_COUPON_BASED_ON_DOMAIN,
});


